
  
// Script Généré le : 03/03/2026 16:22:21 via ModelGenerator.nt
//  PafDocument.ts
// Chemin de sortie : ..\..\..\front-shared\paf-shared\projects\ngx-paf-common\src\lib\Models\PafDocument.ts

import {DocTyp } from "./DocTyp";
import {RseQuestionIndex } from "./RseQuestionIndex";
import {RseQualityDoc } from "./RseQualityDoc";
export class PafDocument {

  // int Id
  public Id: number=0;

  // string Cod
  public Cod?: string=null;

  // int DocTypId
  public DocTypId: number=0;

  // string LblCod
  public LblCod?: string=null;

  // string TemplatePath
  public TemplatePath?: string=null;

  // byte? IsRequired
  public IsRequired?: number=null;

  // int? Duree
  public Duree?: number=null;

  // byte TopInputDat
  public TopInputDat: number=0;

  // string Informations
  public Informations?: string=null;

  // int? CountryId
  public CountryId?: number=null;

  // byte? VisibleSupplier
  public VisibleSupplier?: number=null;

  // byte? TopRelance
  public TopRelance?: number=null;

  // int? Relance1
  public Relance1?: number=null;

  // int? Relance2
  public Relance2?: number=null;

  // int? Relance3
  public Relance3?: number=null;

  // int? Relance4
  public Relance4?: number=null;

  // string DureeUnit
  public DureeUnit?: string=null;

  // byte? TopDatInputIsEcheance
  public TopDatInputIsEcheance?: number=null;

  // string ImportAction
  public ImportAction?: string=null;

  // string Screen
  public Screen?: string=null;

  // byte? TopInputDescription
  public TopInputDescription?: number=null;

  // byte? TopMultiple
  public TopMultiple?: number=null;

  // int? DisplayRank
  public DisplayRank?: number=null;

  // string ShortCod
  public ShortCod?: string=null;

  // string TemplatePathEN
  public TemplatePathEN?: string=null;

  // DocTyp DocTyp
  public DocTyp: DocTyp=null;

  // ICollection<RseQuestionIndex> RseQuestionIndexes
  public RseQuestionIndexes: RseQuestionIndex[]=[];

  // RseQualityDoc RseQualityDoc
  public RseQualityDoc: RseQualityDoc=null;
}